(function (global, factory) {
  if ("function" == typeof define && define.amd) define(["module", "exports"], factory);else if ("undefined" != typeof exports) factory(module, exports);else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports), global.create_success = mod.exports;
  }
})(this, function (module, exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: !0
  }), exports.default = function (resolve, parse) {
    return function (response) {
      response = response ? parse(response) : response, resolve(response);
    };
  };
  module.exports = exports["default"];
});